import React from 'react'
import { ListProducts } from '../products/ListProducts';
import { NewProduct } from '../products/NewProduct';
import { EditProduct } from '../products/EditProduct';
import { useModuleView } from '../../hooks/useModuleView';

export const Products = ({data}) => {


    const viewsMap = {
        list: ListProducts,
        new: NewProduct,
        edit: EditProduct,
    };

    const { view, setView, renderView, contextData } = useModuleView('list', viewsMap);

    return (
        <div className="container-fluid">
            {renderView({parentData:data})}
        </div>
    );
}
